var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"open-in-maps",attrs:{"href":_vm.is_valid ? _vm.maps_href : '#',"target":_vm.is_valid ? _vm.target : '_self',"disabled":!_vm.is_valid,"rel":"noopener noreferrer"}},[_vm._v("Vedi sulla mappa")])
}
var staticRenderFns = []

export { render, staticRenderFns }